import VideoTitle from './VideoTitle';
import VideoBackground from './VideoBackground';
import { RootState } from '../../../../store/appStore';
import { useAppSelector } from '../../../../utils/hooks';

const MainContainer = () => {
  const nowPlayingMovies = useAppSelector(
    (store: RootState) => store.movies.nowPlayingMovies
  );
  if (!nowPlayingMovies.movieList.length) return null;
  const mainMovie = nowPlayingMovies.movieList[0];
  const { id, title, overview } = mainMovie;
  return (
    <div className='dark:bg-gray-900 bg-gray-50'>
      <VideoTitle id={id} title={title} overview={overview} />
      <VideoBackground movieId={id} title={title} />
    </div>
  );
};

export default MainContainer;
